import { useNavigate } from "react-router";

import { AccountItemLine } from "./AccountItem";
import { DSButton } from "../design-system/molecules";

export default function AnalyticsSettings() {
  const navigate = useNavigate();
  return (
    <div
      id="analyticsSection"
      className="flex-1 flex flex-col gap-md"
    >
      <AccountItemLine dataTestId="analytics-line">
        <DSButton
          onClick={() => {
            navigate(`/notebook/analytics/`);
          }}
          dataTestId="view-analytics-button"
        >
          View Patient Analytics
        </DSButton>
      </AccountItemLine>
    </div>
  );
}
